import { useGetOneOrganizationTicket } from '@sib/api';
import { useUserSetupStore } from '@sib/auth';
import { TicketSectionWrapper } from '@spendbrain/modules/tickets/components';
import { TicketDescriptionSection, TicketSubjectSection } from '../Sections';
import { TicketDetailsTabs } from '../TicketDetailsTabs';
import { TicketDetailsSkeleton } from './TicketDetailsSkeleton';

export interface TicketDetailsProps {
  ticketId: string;
}

export const TicketDetails = ({ ticketId }: TicketDetailsProps) => {
  const { organizationId } = useUserSetupStore();

  const { data: ticketData, isLoading } = useGetOneOrganizationTicket(
    ticketId,
    organizationId
  );

  return (
    <div className="mt-0 flex h-full min-h-[700px] flex-col gap-3">
      <div className="flex h-full w-full flex-1 flex-col gap-4">
        {isLoading ? (
          <TicketDetailsSkeleton />
        ) : (
          <>
            <TicketSectionWrapper>
              <TicketSubjectSection ticket={ticketData} />
            </TicketSectionWrapper>
            <TicketSectionWrapper>
              <TicketDescriptionSection ticket={ticketData} />
            </TicketSectionWrapper>
            <TicketSectionWrapper className="h-full flex-1 p-0">
              <TicketDetailsTabs ticket={ticketData} />
            </TicketSectionWrapper>
          </>
        )}
      </div>
    </div>
  );
};
